"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "InformationCircleSmall", {
  enumerable: true,
  get: function () {
    return _InformationCircleSmall.default;
  }
});
Object.defineProperty(exports, "WarningTriangleSmall", {
  enumerable: true,
  get: function () {
    return _WarningTriangleSmall.default;
  }
});
exports.default = void 0;
var _PriceModule = _interopRequireDefault(require("./PriceModule"));
var _WarningTriangleSmall = _interopRequireDefault(require("./elements/WarningTriangleSmall"));
var _InformationCircleSmall = _interopRequireDefault(require("./elements/InformationCircleSmall"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _PriceModule.default;
exports.default = _default;